export default {
  cash: 'Dinheiro',
  other: 'Outro',
  debit_card: 'Cartão Débito',
  credit_card: 'Cartão Crédito'
};
